export default [
  {
    path: 'M796.7 746.9c-52 1.7-100.1 3.3-152 5-32.9 140-305.1 102.2-274.8-75.5 15.2-105.2 157.5-151.2 245.7-71.7 19.4 21.9 28.9 42.3 35.1 86.8 43.6-1.7 102.4-3.3 146-5 2.2-226.4-255-341.3-447.8-231.4C164 560.4 185.4 881.3 379.1 963.2v5c-105.6-2.1-221.5-83.9-246.7-181.1l1.4-522c83.9-57 176.5-125.4 260.4-182.4 3.3 1.7 6.7 3.4 10 5-5.8 78.7-2.1 208.4 2.5 303.1 52.6-51 87.9-104.3 178.6-122 58.5-11.4 114.4-4.5 149.7 7.5 264.9 90.7 281.4 433.1 56.6 550.9-5.1 0-16 9.9-24.3 11.6 0-1.7 5.2-9 9.2-16.6 6.8-25 13.5-50.2 20.2-75.3z',
    fill: '#1D2087',
  },
]
